import { Route } from '@angular/router';
import { AssignToDropdownComponent, DailyReportingComponent, GmDashboardComponent, LoginComponent, NewVendorRegistrationComponent, VendorApprovalComponent, AmDashboardComponent } from '@org/components';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SettingsComponent } from './settings/settings.component';
import { CreateTaskComponent } from './mobile/createTask/create-task/create-task.component';
import { authGuard } from '@org/utilities';
import { TeamComponent } from './team/team.component';
import { ProfileComponent } from './profile/profile.component';
import { noAuthGuard } from '@org/utilities';
import { ReportsComponent } from './reports/reports.component';
import { TaskCompletionReportComponent } from './reports/task-completion-report/task-completion-report.component';
import { AdminComponent } from './admin/tenant/create/admin.component';
import { TenantListComponent } from './admin/tenant/tenantList.component';
import { EomReportComponent } from './reports/eom-report/eom-report.component';
import { MorningMeetingComponent } from './mobile/morning-meeting/morningMeeting.component';
import { VendorTasksComponent } from './vendors/vendorTasks/vendorTask.component';
import { QandAComponent } from './QandA/QandA.component';
import { VendorViewComponent } from './vendors/vendorView/vendorView.component';
import { CSRViewComponent } from './csr-view/csr-view.component';
import { VendorDashboardComponent } from './vendor-dashboard/vendor-dashboard.component';
import { GmAssignmentComponent } from './gm-assignment/gm-assignment.component';

export const appRoutes: Route[] = [
    { path: 'login', component: LoginComponent, canActivate: [noAuthGuard] }, 
    { path: 'dashboard', component: DashboardComponent, canActivate: [authGuard], data: { roles: ['admin', 'gm', 'developer', 'estimator', 'parts coordinator', 'csr', 'porter'] } },
    { path: 'gm-dashboard', redirectTo: 'dashboard', pathMatch: 'full' },
    { path: 'csr-view', component: CSRViewComponent, canActivate: [authGuard], data: { roles: ['admin', 'developer', 'csr', 'gm'] } },
    { path: 'profile', component: ProfileComponent, canActivate: [authGuard], data: { roles: ['admin', 'gm', 'developer', 'estimator', 'csr', 'porter', 'tech', 'vendor', 'am'] } },
    { path: 'team', component: TeamComponent, canActivate: [authGuard], data: { roles: ['admin', 'gm', 'developer', 'am'] } },
    { path: 'settings', component: SettingsComponent, canActivate: [authGuard], data: { roles: ['developer', 'estimator', 'admin', 'gm', 'parts coordinator', 'csr', 'porter', 'tech'] } },
    { path: 'admin', component: AdminComponent, canActivate: [authGuard], data: { roles: ['developer'] } },
    { path: 'tenants', component: TenantListComponent, canActivate: [authGuard], data: { roles: ['developer'] } },
    { path: 'morning-meeting', canActivate: [authGuard], data: { roles: ['tech'] }, component: MorningMeetingComponent },
    { path: 'vendor-registration/:token', component: NewVendorRegistrationComponent },
    {
        path: 'vendor',
        component: VendorViewComponent,
        canActivate: [authGuard],
        data: {
          roles: ['admin', 'gm', 'developer', 'estimator', 'vendor']
        }
    },
    {
        path: 'vdashboard',
        component: VendorDashboardComponent,
        canActivate: [authGuard],
        data: {
          roles: ['vendor', 'developer']
        }
    },
    {
        path: 'vendor-tasks',
        component: VendorTasksComponent,
        canActivate: [authGuard],
        data: {
          roles: ['admin', 'gm', 'developer', 'estimator']
        }
    },
    {
        path: 'vendor-approval',
        component: VendorApprovalComponent,
        canActivate: [authGuard],
        data: {
          roles: ['admin', 'gm', 'developer', 'estimator']
        }
    },
    {
        path: 'mobile/new-task',
        component: CreateTaskComponent,
        canActivate: [authGuard],
        data: {
            roles: ['tech', 'admin', 'developer']
        }
    },
    {
        path: 'reports',
        component: ReportsComponent,
        canActivate: [authGuard],
        data: {
            roles: ['developer', 'gm'] 
            
        }
    },
    { path: 'assignto', component: AssignToDropdownComponent, canActivate: [authGuard], data: { roles: ['developer', 'gm', 'estimator'] } },
    { path: 'QandA', component: QandAComponent, canActivate: [authGuard], data: { roles: ['developer', 'gm', 'estimator', 'tech'] } },
    { path: 'reports/task-completion', component: TaskCompletionReportComponent, canActivate: [authGuard], data: { roles: ['developer', 'gm'] } },
    { path: 'reports/end-of-month', component: EomReportComponent, canActivate: [authGuard], data: { roles: ['developer', 'gm'] } },
    { path: 'reports/day-end', component: DailyReportingComponent, canActivate: [authGuard], data: { roles: ['developer', 'gm'] } },
    { path: 'am-dashboard', component: AmDashboardComponent, canActivate: [authGuard], data: { roles: ['am'] } },
    { path: 'gm-assignment', component: GmAssignmentComponent, canActivate: [authGuard], data: { roles: ['am'] } },
    { path: '', redirectTo: '/login', pathMatch: 'full' },
    { path: '**', component: DashboardComponent, canActivate: [authGuard], data: { roles: ['admin', 'gm', 'developer', 'estimator'] } }
];
